export const SET_DOWNLOAD_APP_FORM_DATA = "SET_DOWNLOAD_APP_FORM_DATA";
export const POST_DOWNLOAD_APP_FORM_DATA_START = "POST_DOWNLOAD_APP_FORM_DATA_START";
export const POST_DOWNLOAD_APP_FORM_DATA_SUCCESS = "POST_DOWNLOAD_APP_FORM_DATA_SUCCESS";
export const POST_DOWNLOAD_APP_FORM_DATA_ERROR = "POST_DOWNLOAD_APP_FORM_DATA_ERROR";
export const POST_DOWNLOAD_APP_FORM_DATA_PROCESS = "POST_DOWNLOAD_APP_FORM_DATA_PROCESS";
export const RESET_DOWNLOAD_APP_FORM_DATA_START = "RESET_DOWNLOAD_APP_FORM_DATA_START";